import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrdersExpandListTemplate = ({
	viewStore,
	fulfillmentOrdersExpandListViewStore,
	fulfillmentOrdersExpandListViewStore: { tableData, noDataItem, data, change, loading },
}) => {
	if (loading) return null;
	return (
		<section>
			<BaasicTable
				{...{
					data,
					tableData,
					fulfillmentOrdersExpandListViewStore,
					noDataItem,
					showImage: false,
					change,
					viewStore
				}}
				actions={fulfillmentOrdersExpandListViewStore}
			/>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(FulfillmentOrdersExpandListTemplate);
